import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eAppYeuCauHoTroActionTypeIds, IAppYeuCauHoTroActionTypes } from "../../action-types/app-phuhuynh/IAppYeuCauHoTroActionTypes";
import { IAppYeuCauHoTroPageState } from "../../page-state-model/app-phuhuynh/IAppYeuCauHoTroState";

const initialState: IAppYeuCauHoTroPageState = {
    status: ePageBaseStatus.is_not_initialization,
    app_yeucauhotros: [],
    app_yeucauhotro_detail: undefined
}

export const appYeuCauHoTroReducer = (state: IAppYeuCauHoTroPageState = initialState, action: IAppYeuCauHoTroActionTypes): IAppYeuCauHoTroPageState => {
    switch (action.type) {
        case eAppYeuCauHoTroActionTypeIds.LOAD_SELECT_START:
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case eAppYeuCauHoTroActionTypeIds.LOAD_SELECT_SUCCESS:
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                app_yeucauhotros: action.payload
            }
        case eAppYeuCauHoTroActionTypeIds.LOAD_SELECT_ERROR:
            NotifyHelper.Error(action.payload)
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                app_yeucauhotros: []
            }
        case eAppYeuCauHoTroActionTypeIds.LOAD_DETAIL_START:
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case eAppYeuCauHoTroActionTypeIds.LOAD_DETAIL_SUCCESS:
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                app_yeucauhotro_detail: action.payload
            }
        case eAppYeuCauHoTroActionTypeIds.LOAD_DETAIL_ERROR:
            NotifyHelper.Error(action.payload)
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                app_yeucauhotro_detail: undefined
            }
        case eAppYeuCauHoTroActionTypeIds.UPDATE_PHANHOI_START:
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case eAppYeuCauHoTroActionTypeIds.UPDATE_PHANHOI_SUCCESS:
            NotifyHelper.Success("Thay đổi dữ liệu thành công.")
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload
            }
        case eAppYeuCauHoTroActionTypeIds.UPDATE_PHANHOI_ERROR:
            NotifyHelper.Error(action.payload)
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        default:
            return state;
    }

}